export default __webpack_public_path__ + "static/build-on-2021-champion-7f26cd0016858bd05833a66d3224f3dc.jpg";